import { createAction, props } from '@ngrx/store';

export const loadCompanyIcon = createAction('[CompanyIcon/API] Load Company Icon');

export const loadCompanyIconSuccess = createAction(
  '[CompanyIcon/API] Load Company Icon Success',
  props<{ url: string }>()
);

export const loadCompanyIconFailure = createAction(
  '[CompanyIcon/API] Load Company Icon Failure',
  props<{ error: any }>()
);

export const updateCompanyIcon = createAction('[CompanyIcon/API] Update Company Icon', props<{ payload: string }>());

export const updateCompanyIconSuccess = createAction(
  '[CompanyIcon/API] Update Company Icon Success',
  props<{ url: string }>()
);

export const updateCompanyIconFailure = createAction(
  '[CompanyIcon/API] Update Company Icon Failure',
  props<{ error: any }>()
);

export const deleteCompanyIcon = createAction('[CompanyIcon/API] Delete CompanyIcon');

export const deleteCompanyIconSuccess = createAction('[CompanyIcon/API] Delete Company Icon Success');

export const deleteCompanyIconFailure = createAction(
  '[CompanyIcon/API] Delete Company Icon Failure',
  props<{ error: any }>()
);

export const clearCompanyIcon = createAction('[CompanyIcon/API] Clear Company Icon');
